import React from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";

export default function Contact() {
  const getCurrentYear = () => new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const handleBackToTop = () => {
    if (isHome) return; 
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 0);
  };

  return (
    <Wrapper>
      <FooterBar>
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>

            {isHome ? (
              <ScrollLink to="home" smooth={true} offset={-80} role="link" aria-label="Scroll to top">
                <LogoBtn as="div" role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter') e.target.click(); }}>
                  <LogoImgEl src="/sare-logo.png" alt="Sare Auctioneers logo" loading="lazy" width={80} height={50} />
                  <div style={{ textAlign: "center" }}>
                    <h1 style={{ fontSize: "20px", fontWeight: 800, margin: 0, color: "#f2caca" }}>SARE</h1>
                    <h2 style={{ fontSize: "14px", fontWeight: 800, margin: 0, color: "#d99194" }}>AUCTIONEERS</h2>
                  </div>
                </LogoBtn>
              </ScrollLink>
            ) : (
              <LogoBtn as="button" onClick={() => navigate("/")}>
                <LogoImgEl src="/sare-logo.png" alt="Sare Auctioneers logo" loading="lazy" width={80} height={50} />
                <div style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: "20px", fontWeight: 800, margin: 0, color: "#f2caca" }}>SARE</h1>
                  <h2 style={{ fontSize: "14px", fontWeight: 800, margin: 0, color: "#d99194" }}>AUCTIONEERS</h2>
                </div>
              </LogoBtn>
            )}

            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span style={{ color: "#f2caca" }}>Sare Auctioneers</span> All Rights Reserved
            </StyleP>

            {isHome ? (
              <BackToTop className="whiteColor animate pointer font13" to="home" smooth={true} offset={-80}>
                Back to top
              </BackToTop>
            ) : (
              <BackToTopButton className="whiteColor animate pointer font13" onClick={handleBackToTop}>
                Back to top
              </BackToTopButton>
            )}
          </InnerWrapper>
        </div>
      </FooterBar>
    </Wrapper>
  );
}

const BackToTopButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  &:hover {
    color: #f2caca !important;
  }
`;

const Wrapper = styled.div`
  width: 100%;
`;

const FooterBar = styled.div`
  background: #321416;
  color: #fff;
`;

const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 550px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const StyleP = styled.p`
  margin: 0;
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;

const LogoBtn = styled.button`
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 0;
`;

const LogoImgEl = styled.img`
  width: 80px;
  height: 50px;
  object-fit: contain;
  display: block;
  z-index: 2;
`;

const BackToTop = styled(ScrollLink)`
  &:hover {
    color: #f2caca !important;
  }
`;
